// extracted by mini-css-extract-plugin
module.exports = {"scrollbarTrack":"CustomScrollBar_scrollbarTrack__M7qh3","scrollbarThumb":"CustomScrollBar_scrollbarThumb__2YatC"};